import { Button } from '../../../../../components/ui/button';
import { trackStorageEvent } from '../../services/storageAnalytics';
import type { PolicyDialogTrackEvent, PolicyDialogTrackProps } from './accessPolicyTargets';

/** Why saving is blocked in an ACL dialog, with the one explicit way forward (review D RD3). */
export function AclStaleNotice(props: { message: string; dirty: boolean; onReload: () => void; trackEvent?: PolicyDialogTrackEvent; trackProps?: PolicyDialogTrackProps }) {
  const reload = () => { trackStorageEvent(props.trackEvent ?? 'feature:storage_container_action', { action: 'acl_reload', ...props.trackProps }); props.onReload(); };
  return <div className="flex flex-wrap items-center gap-2 text-xs text-destructive" role="alert" data-testid="storage-acl-stale">
    <span>{props.message}{props.dirty ? ' Your changes are kept below; saving stays off until you reload.' : ''}</span>
    <Button type="button" variant="outline" size="xs" data-testid="storage-acl-reload" onClick={reload}>{props.dirty ? 'Discard changes and reload' : 'Reload'}</Button>
  </div>;
}
